module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.30809",
      "ably": "static-2.2",
      "ably-hubspot-js": "static-2.5073",
      "atom": "static-1.5434",
      "client-types": "static-1.501",
      "conversations-error-reporting": "static-1.9239",
      "conversations-internal-pub-sub": "static-1.16347",
      "conversations-internal-schema": "static-1.13461",
      "conversations-message-history": "static-1.13639",
      "conversations-test-sdk": "static-1.10851",
      "conversations-visitor-experience-components": "static-1.24172",
      "data-fetching-client": "static-1.10003",
      "head-dlb": "static-1.5007",
      "hs-promise-utils": "static-1.5943",
      "hs-test-utils": "static-1.8389",
      "hubspot-dlb": "static-2.1905",
      "HubStyleTokens": "static-2.11845",
      "I18n": "static-7.1681",
      "immer": "static-1.102",
      "jasmine-immutable": "static-1.3367",
      "jasmine-runner": "static-1.6802",
      "quartz": "static-1.7518",
      "react-dlb": "static-1.90",
      "react-select-plus": "static-1.114",
      "react-transition-group": "static-2.74",
      "redux-thunk": "static-2.81",
      "reselect": "static-3.13",
      "sanitize": "static-1.4824",
      "StyleGuideUI": "static-3.509",
      "transmute": "static-2.97",
      "urlinator": "static-1.4877",
      "usage-tracker": "static-1.7665",
      "usage-tracker-core": "static-1.7515",
      "usage-tracker-public": "static-1.7476",
      "viral-links-lib": "static-1.7428",
      "visitor-ui-component-library": "static-1.6505",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.5165",
      "conversations-visitor-message-history": "static-1.22909",
      "cssUtils": "static-1.976",
      "enviro": "static-4.455",
      "flux-actions": "static-1.375",
      "foundations-components": "static-1.8567",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.6565",
      "interactive-cards": "static-1.423",
      "hubspot-url-utils": "static-1.4366",
      "immutable": "static-2.87",
      "metrics-js": "static-1.9963",
      "PatternValidationJS": "static-1.3244",
      "PortalIdParser": "static-2.404",
      "pulse": "static-1.983",
      "raven": "static-3.5925",
      "react": "static-7.199",
      "react-aria": "static-1.73",
      "react-dom": "static-7.85",
      "react-redux": "static-7.79",
      "react-rhumb": "static-1.17076",
      "react-utils": "static-2.5590",
      "redux": "static-4.80",
      "rpc-client-utils": "static-1.5018",
      "redux-toolkit": "static-1.79",
      "sanitize-text": "static-1.8510",
      "signup-constants": "static-1.19707",
      "styled-components": "static-2.99",
      "usage-tracker-multi": "static-1.6079",
      "visitor-ui-component-library-icons": "static-1.6316",
      "hs-promise-rejection-tracking": "static-1.5587",
      "raven-hubspot": "static-1.6232",
      "hoist-non-react-statics": "static-3.9",
      "moment": "static-3.75",
      "quartz-config": "static-1.1296",
      "quartz-core": "static-1.6737",
      "foundations-assets": "static-1.5239",
      "foundations-theming": "static-1.4830",
      "UIComponents": "static-3.8791",
      "conversations-async-data": "static-2.8020",
      "customer-data-email": "static-1.18583",
      "cv-backend-services": "static-1.1597",
      "immutable-less": "static-1.5003",
      "conversations-skeleton-state": "static-1.7596",
      "crm-events-viz-core": "static-1.34181",
      "customer-data-objects": "static-1.8048",
      "icons": "static-2.695",
      "react-input-autosize": "static-2.17",
      "react-performance-metrics-lib": "static-1.906",
      "ui-images": "static-2.1265",
      "apollo-stack-hubspot": "static-3.95",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.90",
      "HeadJS": "static-2.805",
      "framer-motion": "static-1.80",
      "hs-test-utils-bend-plugin": "static-1.3500",
      "msw": "static-1.39",
      "testing-library": "static-1.159",
      "i18n-data": "static-1.230",
      "moment-timezone": "static-5.92",
      "jasmine": "static-4.4665",
      "signup-ui-url-generator": "static-2.8412",
      "quartz-i18n": "static-1.1193",
      "sassPrefix": "static-1.242",
      "bend-plugin-foundations-components": "static-1.4836",
      "floating-ui": "static-1.64",
      "foundations-theming-specialty": "static-1.2546",
      "hs-story-utils": "static-1.9777",
      "react-create-root-preference": "static-1.80",
      "react-virtualized": "static-2.108",
      "tanstack-table": "static-1.62",
      "trellis-assets": "static-1.2763",
      "ui-fonts": "static-1.1107",
      "hs-locale-management": "static-1.328",
      "dompurify": "static-1.9",
      "utility-belt": "static-1.2885",
      "bend-plugin-pulse": "static-1.486",
      "batch-promise": "static-1.1897",
      "chirp-fetch": "static-1.2250",
      "event-emitter": "static-1.1310",
      "fast-json-patch": "static-1.71",
      "hub-http-janus": "static-1.889",
      "quick-fetch": "static-1.4159",
      "csstype": "static-1.50",
      "quartz-head": "static-1.1183",
      "web-vitals": "static-1.16",
      "bend-plugin-chirp-manifest": "static-1.428",
      "quartz-routing": "static-1.948",
      "usage-tracker-anonymous": "static-1.6082",
      "opentelemetry-fe-types": "static-1.132",
      "dispatcher": "static-1.144",
      "general-store": "static-6.20",
      "hubspotter-http": "static-1.4895",
      "mobile-manifest-mixins": "static-1.585",
      "module-federation": "static-1.34",
      "opentelemetry-fe": "static-1.507",
      "quartz-auth": "static-1.1193",
      "quartz-test": "static-1.1193",
      "quartz-tracking": "static-1.897",
      "trellis-components": "static-1.2782",
      "usage-tracker-container": "static-1.7655",
      "bend-plugin-foundations-theming": "static-1.3313",
      "foundations-theming-base": "static-1.3815",
      "stylex": "static-1.42",
      "HubStyle": "static-2.12152",
      "react-immutable-proptypes": "static-2.8",
      "apollo-dlb": "static-3.98",
      "apollo-link-hub-http": "static-2.5005",
      "customer-data-ui-utilities": "static-1.10184",
      "FileManagerCore": "static-1.40107",
      "FileManagerLib": "static-1.40248",
      "hubspot-apollo-client": "static-1.5228",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.613",
      "timezone-utils": "static-2.5590",
      "ui-gdpr-components": "static-1.10644",
      "ts-schema": "static-1.4327",
      "ai-components-ui-library": "static-1.9816",
      "avatar-components": "static-1.2837",
      "content-assistance-lib": "static-1.8266",
      "crm-component-utils": "static-1.39938",
      "crm-display-components": "static-1.25688",
      "crm-fe-perf": "static-1.23251",
      "crm-links": "static-1.6658",
      "crm-message-bus": "static-1.43864",
      "crm-search-service-types": "static-1.1495",
      "crm-source-interpretation-lib": "static-1.5684",
      "customer-data-communicator": "static-1.46436",
      "customer-data-filters-ui": "static-1.41058",
      "customer-data-objects-ui-components": "static-1.13384",
      "customer-data-properties": "static-1.52727",
      "customer-data-rte": "static-1.33719",
      "draft-plugins": "static-2.22219",
      "file-manager-components": "static-1.24608",
      "trellis-theming": "static-1.1327",
      "framework-data-schema-resolvers": "static-1.7247",
      "frontend-preferences-client": "static-1.8271",
      "hubspot-prosemirror": "static-1.19071",
      "object-comments-thread-lib": "static-1.11419",
      "prosemirror-user-and-team-at-mentions": "static-1.1278",
      "reference-resolvers-lite": "static-1.8456",
      "ui-addon-upgrades": "static-9.18445",
      "universal-associations-select": "static-1.11432",
      "universal-record-utils-lib": "static-1.2097",
      "wootric-nps": "static-1.7232",
      "inbound-db-properties-service-client": "static-1.4081",
      "property-translator": "static-1.5740",
      "segments-query-core": "static-1.1778",
      "bender-build-tools": "static-1.3452",
      "stylex-utils": "static-1.149",
      "opentelemetry-web": "static-1.15",
      "beacon-keepalive-queue": "static-1.58",
      "hub-http-shared-msw-handlers": "static-1.10703",
      "hubspotter-http-shared-msw-handlers": "static-1.10701",
      "usage-tracker-session-replay": "static-1.5351",
      "base-ui": "static-1.23",
      "react-day-picker": "static-1.11",
      "tanstack-virtual": "static-1.39",
      "react-dnd-compat": "static-1.4968",
      "breeze-artifacts-sdk": "static-1.513",
      "copilot-toolkit": "static-1.11934",
      "audio-components": "static-1.6413",
      "ContentUtils": "static-1.69223",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29880",
      "FileManagerImages": "static-1.37759",
      "foundations-components-legacy": "static-1.1592",
      "html-to-image": "static-1.62",
      "immerable": "static-1.4498",
      "react-colorpicker": "static-2.10567",
      "ui-universal-auth": "static-1.9493",
      "video-components": "static-1.14236",
      "video-data-lib": "static-1.35892",
      "video-embed": "static-1.36726",
      "hubspot-apollo-cache": "static-1.687",
      "chatspot-core": "static-1.23262",
      "superstore": "static-1.5113",
      "ui-addon-video-player": "static-1.9050",
      "ui-coaching-tips": "static-1.29398",
      "card-properties-lib": "static-1.45104",
      "commerce-subscription-lib": "static-1.37878",
      "crm-actions": "static-1.6702",
      "crm-cards-sdk": "static-1.44699",
      "customer-data-properties-shared-msw-handlers": "static-1.10030",
      "customer-data-property-utils": "static-1.8446",
      "customer-data-tracking": "static-1.7229",
      "hs-resources": "static-1.546",
      "inbound-db-meta-service-client": "static-1.3718",
      "framework-data-table": "static-2.12637",
      "location-customization-utils-lib": "static-1.10199",
      "restore-request-side-panel-lib": "static-1.1767",
      "calling-error-reporting": "static-1.31681",
      "calling-internal-common": "static-1.31674",
      "calling-usage-tracker": "static-1.6889",
      "crm_data": "static-4.92944",
      "customer-data-content": "static-1.27868",
      "draft-content-plugins": "static-1.28978",
      "draft-convert": "static-2.81",
      "draft-extend": "static-3.84",
      "draft-js": "static-5.86",
      "draft-signature-plugin": "static-1.24792",
      "EmailSignatureEditor": "static-1.25072",
      "hubspot-prosemirror-plugins": "static-1.19063",
      "integration-settings-components": "static-1.16296",
      "integrations-lib": "static-1.17167",
      "integrations-tracking-lib": "static-1.5963",
      "native-integrations-shared-strings": "static-1.8125",
      "nav-meta": "static-1.30560",
      "onboarding-scopes": "static-1.6805",
      "outreach-assistant-email-generation": "static-1.6891",
      "prosemirror": "static-1.13",
      "prosemirror-copilot": "static-1.12400",
      "quotes-client-types": "static-1.38956",
      "reference-resolvers": "static-1.8533",
      "rich-text-lib": "static-1.20378",
      "sales-email-signature-service-client": "static-1.4200",
      "sequences-lib": "static-1.8599",
      "ui-addon-i18n": "static-1.11500",
      "ui-addon-iframeable": "static-1.9430",
      "ui-business-units-lib": "static-1.9444",
      "ui-shepherd-react": "static-3.10624",
      "user-context": "static-1.5469",
      "whatsapp-sending-lib": "static-1.6859",
      "customer-data-filters-ui-msw-helpers": "static-1.23493",
      "customer-data-reference-ui-components": "static-1.13527",
      "events-data-lib": "static-1.601",
      "FormUrlGenerator": "static-2.5074",
      "framework-builder-read-service-client": "static-1.4255",
      "multi-account-reference-resolvers": "static-1.1359",
      "onboarding-tours": "static-1.17207",
      "reporting-datasets-permissions-lib": "static-1.14553",
      "segments-client-types": "static-1.11708",
      "SharedI18nStrings": "static-1.184",
      "ui-addon-teams": "static-1.21960",
      "calling-global-api": "static-1.65777",
      "calling-lifecycle-internal": "static-1.67159",
      "calling-lifecycle-messages": "static-1.59453",
      "commerce-products-lib": "static-1.10643",
      "conditional-properties-service-client": "static-1.4050",
      "crm-index-visualization-core": "static-1.4598",
      "crm-pipelines-api-client-types": "static-1.4381",
      "external-options-client-types": "static-1.4374",
      "formula-editor": "static-1.14839",
      "google-libphonenumber": "static-1.46",
      "inbounddb-objects-service-types": "static-1.4458",
      "meetings-icalendar-utils-lib": "static-1.988",
      "multi-currency-client-types": "static-1.3941",
      "object-builder-ui-client": "static-1.49790",
      "pipeline-validation-client-types": "static-1.4216",
      "property-value-citations": "static-1.3341",
      "smart-data-capture-core": "static-1.221",
      "smart-property-lib": "static-1.8403",
      "tiered-pricing": "static-1.2038",
      "topics-actions-lib": "static-1.523",
      "trial-components-library": "static-1.14190",
      "ui-addon-form-validation": "static-1.11332",
      "zustand": "static-1.86",
      "breeze-engine-lib": "static-1.1869",
      "video-components-external": "static-1.12234",
      "fdsr-migration-layer": "static-1.366",
      "framework-data-schema-quick-fetch": "static-1.7152",
      "persist-promise": "static-1.4054",
      "content-media-capture": "static-1.5541",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.26280",
      "knowledge-content-types": "static-1.8697",
      "payment-link-components": "static-1.24235",
      "ui-addon-emoji-picker": "static-1.10231",
      "call-summary": "static-1.40467",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.10849",
      "laboratory-lib": "static-3.7505",
      "merchandise-lib": "static-1.279",
      "purchase-motions-components": "static-1.6465",
      "crm-object-search-query-utilities": "static-1.10275",
      "amplitude-session-replay-browser": "static-1.60",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "magpie-lib": "static-1.5793",
      "magpie-types": "static-1.5253",
      "simple-logging-lib": "static-1.3403",
      "cms-field-types": "static-1.5164",
      "content-icons-ui": "static-1.2410",
      "underscore": "static-1.8",
      "nudge-client-utils": "static-1.3220",
      "unified-auth-core-lib": "static-1.1289",
      "social-insights-client-types": "static-1.22728",
      "outpost": "static-1.4499",
      "markdown-it": "static-1.6",
      "growth-onboarding-feedback-components": "static-1.6938",
      "customer-data-sidebar": "static-2.46822",
      "enrichment-lib": "static-1.588",
      "ui-addon-draggable-compat": "static-2.4615",
      "commerce-billing-lib": "static-1.20307",
      "commerce-shared-components-lib": "static-1.19340",
      "commerce-tools-ui-lib": "static-1.11132",
      "customer-data-associations": "static-1.7682",
      "tasks-actions-lib": "static-1.230",
      "reporting-data": "static-1.68971",
      "ui-addon-draggable": "static-3.5105",
      "crm-record-cards-service-types": "static-1.3800",
      "crm_universal": "static-1.22555",
      "SalesContentIndexUI": "static-3.9675",
      "content-embed-lib": "static-1.7690",
      "data-model-builder-lib": "static-1.13257",
      "remote-dom": "static-1.5",
      "remote-ui": "static-1.72",
      "ui-components-test-utils": "static-1.5982",
      "ui-extensions-remote-renderer": "static-1.17978",
      "universal-page-editor-lib": "static-1.3362",
      "integrations-error-boundary-lib": "static-1.14582",
      "redux-observable": "static-1.76",
      "ReduxMessenger": "static-2.10724",
      "rxjs": "static-5.10",
      "unified-auth": "static-1.1007",
      "ai-addon-copilot-preview": "static-1.9028",
      "data-token-picker": "static-1.16956",
      "sequences-client-types-lib": "static-1.8456",
      "foundations-components-test-utils": "static-1.6050",
      "navigation-messaging": "static-1.8250",
      "getting-started-shared-tasks": "static-1.19341",
      "getting-started-shared-tasks-store": "static-1.18459",
      "onboarding-tours-utils": "static-1.1274",
      "messaging-usage-based-billing-components-lib": "static-1.2111",
      "marketing-platform-lib": "static-1.7226",
      "whatsapp-management-lib": "static-1.10018",
      "growth-data-modal": "static-1.5963",
      "growth-onboarding-confetti": "static-1.3418",
      "growth-onboarding-next-action-utils": "static-1.2779",
      "navigation-components": "static-1.18923",
      "onboarding-tours-client": "static-1.5422",
      "ui-shepherd-tracker": "static-1.8005",
      "crm-index-associations-lib": "static-1.6798",
      "shared-worker-versioning": "static-1.11394",
      "voice-sms-access-library": "static-1.2165",
      "commerce-permissions": "static-1.1130",
      "products-iframe-lib": "static-1.8674",
      "products-ui-components-shared-msw-handlers": "static-1.11085",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10786",
      "sales-views-client-types": "static-1.4609",
      "bark-lib": "static-1.16870",
      "browser-prettier": "static-1.11",
      "codemirror": "static-5.103",
      "crm-properties-common-lib": "static-1.6242",
      "react-codemirror": "static-1.10996",
      "data-agent-kit": "static-1.720",
      "fsm": "static-1.4106",
      "policy-lib": "static-1.7159",
      "embedded-academy-lib": "static-1.15679",
      "hubs-service-types": "static-1.1613",
      "purchase-motions-api": "static-1.6468",
      "breeze-engine-chat-components": "static-1.847",
      "breeze-engine-core": "static-1.1147",
      "highlight.js": "static-1.87",
      "content-media-composition-data-lib": "static-1.13345",
      "content-media-compositions": "static-2.17352",
      "idb-keyval": "static-1.52",
      "media-bridge-lib": "static-1.19474",
      "fix-webm-duration": "static-1.31",
      "notification-sounds": "static-1.4777",
      "seat-types-lib": "static-1.806",
      "ui-addon-opt": "static-4.8714",
      "commerce-tours-lib": "static-1.6693",
      "growth-onboarding-reliability": "static-1.5434",
      "sales-checkout-service-client": "static-1.3882",
      "calling-cross-tab-library": "static-1.19652",
      "calling-lifecycle-usage-tracker": "static-1.9467",
      "reactive-lib": "static-1.1071",
      "nudge-custom-function-registry": "static-1.2977",
      "nudge-renderer-utils": "static-1.3296",
      "whisper-core-api": "static-1.7419",
      "card-payment-highlight-lib": "static-1.38091",
      "commerce-contract-lib": "static-1.13492",
      "invoices-highlight-card-lib": "static-1.55877",
      "orders-highlight-card-lib": "static-1.22283",
      "products-highlight-card-lib": "static-1.18926",
      "quotes-highlight-card-lib": "static-1.72866",
      "data-agent-utils": "static-1.650",
      "usage-based-billing-components-lib": "static-1.10425",
      "payments-enrollment-embed-lib": "static-1.23933",
      "stripe-embedded-components": "static-1.8064",
      "growth-onboarding-empty-states": "static-1.6355",
      "InboxConnectUtils": "static-4.15645",
      "payments-post-enroll-local-storage-lib": "static-1.5456",
      "qrcode-generator": "static-1.77",
      "reporting-client-types": "static-1.2722",
      "react-flip-move": "static-1.79",
      "FireAlarmUi": "static-1.4756",
      "sales-templates-service-types-lib": "static-1.4418",
      "ui-asset-management-lib": "static-1.11455",
      "association-settings-lib": "static-1.11104",
      "collaboration-sidebar": "static-1.58818",
      "conditional-property-settings-components": "static-1.338",
      "conditional-property-settings-modal": "static-1.13249",
      "data-model-commons-lib": "static-1.13475",
      "ExportDialog": "static-6.10732",
      "final-form": "static-1.79",
      "property-management-iframe": "static-1.14229",
      "property-usages-lib": "static-1.5862",
      "reactflow": "static-1.72",
      "simple-data-table": "static-1.3604",
      "used-in-list-lib": "static-1.7320",
      "visual-association": "static-1.6247",
      "highcharts": "static-8.112",
      "reporting-visualizations": "static-1.61045",
      "ui-extensibility-client-types": "static-1.4270",
      "adobe-sign-auth-lib": "static-1.557",
      "ads-unified-auth-lib": "static-1.1544",
      "custom-vendor-connection-lib": "static-1.57",
      "google-sheets-integration-lib": "static-1.1120",
      "microsoft-drive-auth-lib": "static-1.253",
      "surveymonkey-integration-lib": "static-1.595",
      "slack-ui-library": "static-1.10751",
      "ai-rendering-library": "static-1.11189",
      "ai-settings-ui-library": "static-1.8411",
      "breeze-engine-ui-devtools": "static-1.243",
      "copilot-plugins": "static-1.11906",
      "messaging-shared-utils-lib": "static-1.1560",
      "messaging-user-info-utils-lib": "static-1.1730",
      "content-whatsapp-service-types": "static-1.584",
      "short-messages-app-service-client": "static-1.4273",
      "ui-tool-access": "static-1.10507",
      "onboarding-data-sync-lib": "static-1.2601",
      "growth-onboarding-next-action-components": "static-1.2807",
      "user-context-client": "static-1.4862",
      "nest": "static-1.589",
      "calling-orchestration-schema": "static-1.36942",
      "diff-match-patch": "static-1.7",
      "react-reducer-toolkit": "static-1.16452",
      "browser-eslint": "static-2.57",
      "trellis-story-utils": "static-1.4860",
      "storybook-react": "static-1.41",
      "academy-common-lib": "static-1.15139",
      "js-cookie": "static-1.18",
      "products-ui-components": "static-1.41161",
      "settings-ui-lib": "static-1.12876",
      "accounting-integrations-ui-components": "static-1.7606",
      "invoices-ui-lib": "static-1.55893",
      "commerce-products-api": "static-1.2749",
      "invoices-iframe-lib": "static-1.57951",
      "quotes-modal-lib": "static-1.103544",
      "quotes-ui-lib": "static-1.81587",
      "one-click-checkout": "static-1.517",
      "platform-infra-nav-components": "static-1.7927",
      "reporting-ui-components": "static-2.66240",
      "subscription-experience-data-types": "static-1.15293",
      "marketplace-ui-apps-core": "static-1.19363",
      "stripe-connect-js": "static-1.78",
      "ui-addon-react-router-dom": "static-1.9885",
      "hub-http-contrib": "static-1.3387",
      "ui-addon-sales-email": "static-1.5561",
      "nested-table": "static-1.588",
      "chatspot-widget-iframe": "static-1.23253",
      "collaboration-sidebar-common": "static-1.3615",
      "conditional-property-settings-data": "static-1.356",
      "property-management-common": "static-1.6517",
      "d3": "static-1.7",
      "breeze-onboarding-components": "static-1.828",
      "global-styles-ai-lib": "static-1.240",
      "marketplace-embed-ba": "static-1.709",
      "mermaid": "static-1.3",
      "reporting-action-components": "static-1.42154",
      "reporting-snowflake": "static-1.57587",
      "upgrade-components-lib": "static-1.582",
      "ui-brand-identity-lib": "static-1.16658",
      "meetings-connect-utils-lib": "static-1.7964",
      "academy-service-client": "static-1.4044",
      "croppie": "static-2.10",
      "SafeStorage": "static-1.4753",
      "trellis-ecosystem": "static-1.7694",
      "commerce-tax-lib": "static-1.892",
      "price-books-api": "static-1.1818",
      "price-books-components": "static-1.1876",
      "property-description-translator": "static-1.4183",
      "ramp-editor": "static-1.972",
      "commerce-analytics-service-client": "static-1.3870",
      "totals-ui-components": "static-1.24375",
      "checkout-sdk": "static-3.24455",
      "payment-method-components": "static-1.7199",
      "touchless-buying-components": "static-1.6323",
      "upgrade-catalog-service-types": "static-1.3796",
      "reporting-plugins": "static-1.10826",
      "reporting-reports": "static-1.68647",
      "edison-service-client-types": "static-1.749",
      "developer-experience-shared-components": "static-1.10890",
      "marketplace-ui-client-types": "static-1.18238",
      "marketplace-ui-common": "static-1.20831",
      "ui-addon-integrations-directory-panel": "static-2.8375",
      "react-window": "static-1.13",
      "ts-utils-lib": "static-1.501",
      "onboarding-journeys-lib": "static-1.1029",
      "marketplace-embed": "static-1.23006",
      "marketplace-ui-install": "static-1.817",
      "marketplace-ui-tracking": "static-1.15001",
      "dashboard-lib": "static-1.82984",
      "share-with-third-party-component-lib": "static-1.9062",
      "ContentData": "static-1.69298",
      "line-items-api": "static-1.1158",
      "commerce-totals-service-types": "static-1.4066",
      "hub-http-rxjs": "static-1.856",
      "normalizr": "static-3.9",
      "ramda": "static-1.7",
      "billing-payments-client-types": "static-1.4344",
      "company-details-components": "static-1.6559",
      "emoji-regex": "static-1.7",
      "pricing-pages-ui-components": "static-1.16020",
      "quote-checkout-service-types": "static-1.3807",
      "campaign-roi-lib": "static-1.10479",
      "campaigns-utils-lib": "static-1.3580",
      "ui-addon-calendars": "static-2.5698",
      "apps-service-types": "static-1.4067",
      "oauth-service-types": "static-1.4586",
      "ui-product-approvals-common": "static-1.1215",
      "connections-embed-lib": "static-1.1581",
      "fail-safe": "static-1.308",
      "ai-studio-lib": "static-1.12513",
      "integrations-reconnect-lib": "static-1.554",
      "ui-product-approvals": "static-1.29320",
      "redux-actions": "static-3.71",
      "advanced-menus-core": "static-1.15643",
      "advanced-menus-lib": "static-1.12506",
      "ui-memberships-settings-lib": "static-1.34933",
      "company-details-service-types": "static-1.4295",
      "pricing-pages-api": "static-1.15885",
      "copilot-messaging": "static-1.2184",
      "bend-plugin-fail-safe": "static-1.259",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.15642",
      "simple-menus-lib": "static-1.17159"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.30809",
      "ably": "/ably/static-2.2",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.5073",
      "atom": "/atom/static-1.5434",
      "client-types": "/client-types/static-1.501",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.9239",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.16347",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.13461",
      "conversations-message-history": "/conversations-message-history/static-1.13639",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10851",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.24172",
      "data-fetching-client": "/data-fetching-client/static-1.10003",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-promise-utils": "/hs-promise-utils/static-1.5943",
      "hs-test-utils": "/hs-test-utils/static-1.8389",
      "hubspot-dlb": "/hubspot-dlb/static-2.1905",
      "HubStyleTokens": "/HubStyleTokens/static-2.11845",
      "I18n": "/I18n/static-7.1681",
      "immer": "/immer/static-1.102",
      "jasmine-immutable": "/jasmine-immutable/static-1.3367",
      "jasmine-runner": "/jasmine-runner/static-1.6802",
      "quartz": "/quartz/static-1.7518",
      "react-dlb": "/react-dlb/static-1.90",
      "react-select-plus": "/react-select-plus/static-1.114",
      "react-transition-group": "/react-transition-group/static-2.74",
      "redux-thunk": "/redux-thunk/static-2.81",
      "reselect": "/reselect/static-3.13",
      "sanitize": "/sanitize/static-1.4824",
      "StyleGuideUI": "/StyleGuideUI/static-3.509",
      "transmute": "/transmute/static-2.97",
      "urlinator": "/urlinator/static-1.4877",
      "usage-tracker": "/usage-tracker/static-1.7665",
      "usage-tracker-core": "/usage-tracker-core/static-1.7515",
      "usage-tracker-public": "/usage-tracker-public/static-1.7476",
      "viral-links-lib": "/viral-links-lib/static-1.7428",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6505",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.5165",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.22909",
      "cssUtils": "/cssUtils/static-1.976",
      "enviro": "/enviro/static-4.455",
      "flux-actions": "/flux-actions/static-1.375",
      "foundations-components": "/foundations-components/static-1.8567",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.6565",
      "interactive-cards": "/interactive-cards/static-1.423",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4366",
      "immutable": "/immutable/static-2.87",
      "metrics-js": "/metrics-js/static-1.9963",
      "PatternValidationJS": "/PatternValidationJS/static-1.3244",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "pulse": "/pulse/static-1.983",
      "raven": "/raven/static-3.5925",
      "react": "/react/static-7.199",
      "react-aria": "/react-aria/static-1.73",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.79",
      "react-rhumb": "/react-rhumb/static-1.17076",
      "react-utils": "/react-utils/static-2.5590",
      "redux": "/redux/static-4.80",
      "rpc-client-utils": "/rpc-client-utils/static-1.5018",
      "redux-toolkit": "/redux-toolkit/static-1.79",
      "sanitize-text": "/sanitize-text/static-1.8510",
      "signup-constants": "/signup-constants/static-1.19707",
      "styled-components": "/styled-components/static-2.99",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.6079",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.6316",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "moment": "/moment/static-3.75",
      "quartz-config": "/quartz-config/static-1.1296",
      "quartz-core": "/quartz-core/static-1.6737",
      "foundations-assets": "/foundations-assets/static-1.5239",
      "foundations-theming": "/foundations-theming/static-1.4830",
      "UIComponents": "/UIComponents/static-3.8791",
      "conversations-async-data": "/conversations-async-data/static-2.8020",
      "customer-data-email": "/customer-data-email/static-1.18583",
      "cv-backend-services": "/cv-backend-services/static-1.1597",
      "immutable-less": "/immutable-less/static-1.5003",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7596",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.34181",
      "customer-data-objects": "/customer-data-objects/static-1.8048",
      "icons": "/icons/static-2.695",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.906",
      "ui-images": "/ui-images/static-2.1265",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.95",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.90",
      "HeadJS": "/HeadJS/static-2.805",
      "framer-motion": "/framer-motion/static-1.80",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3500",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.159",
      "i18n-data": "/i18n-data/static-1.230",
      "moment-timezone": "/moment-timezone/static-5.92",
      "jasmine": "/jasmine/static-4.4665",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8412",
      "quartz-i18n": "/quartz-i18n/static-1.1193",
      "sassPrefix": "/sassPrefix/static-1.242",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4836",
      "floating-ui": "/floating-ui/static-1.64",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2546",
      "hs-story-utils": "/hs-story-utils/static-1.9777",
      "react-create-root-preference": "/react-create-root-preference/static-1.80",
      "react-virtualized": "/react-virtualized/static-2.108",
      "tanstack-table": "/tanstack-table/static-1.62",
      "trellis-assets": "/trellis-assets/static-1.2763",
      "ui-fonts": "/ui-fonts/static-1.1107",
      "hs-locale-management": "/hs-locale-management/static-1.328",
      "dompurify": "/dompurify/static-1.9",
      "utility-belt": "/utility-belt/static-1.2885",
      "bend-plugin-pulse": "/bend-plugin-pulse/static-1.486",
      "batch-promise": "/batch-promise/static-1.1897",
      "chirp-fetch": "/chirp-fetch/static-1.2250",
      "event-emitter": "/event-emitter/static-1.1310",
      "fast-json-patch": "/fast-json-patch/static-1.71",
      "hub-http-janus": "/hub-http-janus/static-1.889",
      "quick-fetch": "/quick-fetch/static-1.4159",
      "csstype": "/csstype/static-1.50",
      "quartz-head": "/quartz-head/static-1.1183",
      "web-vitals": "/web-vitals/static-1.16",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.428",
      "quartz-routing": "/quartz-routing/static-1.948",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6082",
      "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.132",
      "dispatcher": "/dispatcher/static-1.144",
      "general-store": "/general-store/static-6.20",
      "hubspotter-http": "/hubspotter-http/static-1.4895",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.585",
      "module-federation": "/module-federation/static-1.34",
      "opentelemetry-fe": "/opentelemetry-fe/static-1.507",
      "quartz-auth": "/quartz-auth/static-1.1193",
      "quartz-test": "/quartz-test/static-1.1193",
      "quartz-tracking": "/quartz-tracking/static-1.897",
      "trellis-components": "/trellis-components/static-1.2782",
      "usage-tracker-container": "/usage-tracker-container/static-1.7655",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3313",
      "foundations-theming-base": "/foundations-theming-base/static-1.3815",
      "stylex": "/stylex/static-1.42",
      "HubStyle": "/HubStyle/static-2.12152",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "apollo-dlb": "/apollo-dlb/static-3.98",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5005",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10184",
      "FileManagerCore": "/FileManagerCore/static-1.40107",
      "FileManagerLib": "/FileManagerLib/static-1.40248",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5228",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.613",
      "timezone-utils": "/timezone-utils/static-2.5590",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10644",
      "ts-schema": "/ts-schema/static-1.4327",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.9816",
      "avatar-components": "/avatar-components/static-1.2837",
      "content-assistance-lib": "/content-assistance-lib/static-1.8266",
      "crm-component-utils": "/crm-component-utils/static-1.39938",
      "crm-display-components": "/crm-display-components/static-1.25688",
      "crm-fe-perf": "/crm-fe-perf/static-1.23251",
      "crm-links": "/crm-links/static-1.6658",
      "crm-message-bus": "/crm-message-bus/static-1.43864",
      "crm-search-service-types": "/crm-search-service-types/static-1.1495",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5684",
      "customer-data-communicator": "/customer-data-communicator/static-1.46436",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41058",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13384",
      "customer-data-properties": "/customer-data-properties/static-1.52727",
      "customer-data-rte": "/customer-data-rte/static-1.33719",
      "draft-plugins": "/draft-plugins/static-2.22219",
      "file-manager-components": "/file-manager-components/static-1.24608",
      "trellis-theming": "/trellis-theming/static-1.1327",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7247",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.8271",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19071",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.11419",
      "prosemirror-user-and-team-at-mentions": "/prosemirror-user-and-team-at-mentions/static-1.1278",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8456",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18445",
      "universal-associations-select": "/universal-associations-select/static-1.11432",
      "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2097",
      "wootric-nps": "/wootric-nps/static-1.7232",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4081",
      "property-translator": "/property-translator/static-1.5740",
      "segments-query-core": "/segments-query-core/static-1.1778",
      "bender-build-tools": "/bender-build-tools/static-1.3452",
      "stylex-utils": "/stylex-utils/static-1.149",
      "opentelemetry-web": "/opentelemetry-web/static-1.15",
      "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.58",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10703",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10701",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5351",
      "base-ui": "/base-ui/static-1.23",
      "react-day-picker": "/react-day-picker/static-1.11",
      "tanstack-virtual": "/tanstack-virtual/static-1.39",
      "react-dnd-compat": "/react-dnd-compat/static-1.4968",
      "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.513",
      "copilot-toolkit": "/copilot-toolkit/static-1.11934",
      "audio-components": "/audio-components/static-1.6413",
      "ContentUtils": "/ContentUtils/static-1.69223",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29880",
      "FileManagerImages": "/FileManagerImages/static-1.37759",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1592",
      "html-to-image": "/html-to-image/static-1.62",
      "immerable": "/immerable/static-1.4498",
      "react-colorpicker": "/react-colorpicker/static-2.10567",
      "ui-universal-auth": "/ui-universal-auth/static-1.9493",
      "video-components": "/video-components/static-1.14236",
      "video-data-lib": "/video-data-lib/static-1.35892",
      "video-embed": "/video-embed/static-1.36726",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.687",
      "chatspot-core": "/chatspot-core/static-1.23262",
      "superstore": "/superstore/static-1.5113",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.9050",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.29398",
      "card-properties-lib": "/card-properties-lib/static-1.45104",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37878",
      "crm-actions": "/crm-actions/static-1.6702",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.44699",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10030",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.8446",
      "customer-data-tracking": "/customer-data-tracking/static-1.7229",
      "hs-resources": "/hs-resources/static-1.546",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
      "framework-data-table": "/framework-data-table/static-2.12637",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10199",
      "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1767",
      "calling-error-reporting": "/calling-error-reporting/static-1.31681",
      "calling-internal-common": "/calling-internal-common/static-1.31674",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6889",
      "crm_data": "/crm_data/static-4.92944",
      "customer-data-content": "/customer-data-content/static-1.27868",
      "draft-content-plugins": "/draft-content-plugins/static-1.28978",
      "draft-convert": "/draft-convert/static-2.81",
      "draft-extend": "/draft-extend/static-3.84",
      "draft-js": "/draft-js/static-5.86",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.24792",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25072",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19063",
      "integration-settings-components": "/integration-settings-components/static-1.16296",
      "integrations-lib": "/integrations-lib/static-1.17167",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5963",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8125",
      "nav-meta": "/nav-meta/static-1.30560",
      "onboarding-scopes": "/onboarding-scopes/static-1.6805",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.6891",
      "prosemirror": "/prosemirror/static-1.13",
      "prosemirror-copilot": "/prosemirror-copilot/static-1.12400",
      "quotes-client-types": "/quotes-client-types/static-1.38956",
      "reference-resolvers": "/reference-resolvers/static-1.8533",
      "rich-text-lib": "/rich-text-lib/static-1.20378",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4200",
      "sequences-lib": "/sequences-lib/static-1.8599",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11500",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9430",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.9444",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10624",
      "user-context": "/user-context/static-1.5469",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.6859",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23493",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13527",
      "events-data-lib": "/events-data-lib/static-1.601",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.5074",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4255",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1359",
      "onboarding-tours": "/onboarding-tours/static-1.17207",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14553",
      "segments-client-types": "/segments-client-types/static-1.11708",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.184",
      "ui-addon-teams": "/ui-addon-teams/static-1.21960",
      "calling-global-api": "/calling-global-api/static-1.65777",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67159",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59453",
      "commerce-products-lib": "/commerce-products-lib/static-1.10643",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4050",
      "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4598",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4381",
      "external-options-client-types": "/external-options-client-types/static-1.4374",
      "formula-editor": "/formula-editor/static-1.14839",
      "google-libphonenumber": "/google-libphonenumber/static-1.46",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4458",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.988",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3941",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.49790",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4216",
      "property-value-citations": "/property-value-citations/static-1.3341",
      "smart-data-capture-core": "/smart-data-capture-core/static-1.221",
      "smart-property-lib": "/smart-property-lib/static-1.8403",
      "tiered-pricing": "/tiered-pricing/static-1.2038",
      "topics-actions-lib": "/topics-actions-lib/static-1.523",
      "trial-components-library": "/trial-components-library/static-1.14190",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11332",
      "zustand": "/zustand/static-1.86",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.1869",
      "video-components-external": "/video-components-external/static-1.12234",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.366",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7152",
      "persist-promise": "/persist-promise/static-1.4054",
      "content-media-capture": "/content-media-capture/static-1.5541",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.26280",
      "knowledge-content-types": "/knowledge-content-types/static-1.8697",
      "payment-link-components": "/payment-link-components/static-1.24235",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10231",
      "call-summary": "/call-summary/static-1.40467",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10849",
      "laboratory-lib": "/laboratory-lib/static-3.7505",
      "merchandise-lib": "/merchandise-lib/static-1.279",
      "purchase-motions-components": "/purchase-motions-components/static-1.6465",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10275",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "magpie-lib": "/magpie-lib/static-1.5793",
      "magpie-types": "/magpie-types/static-1.5253",
      "simple-logging-lib": "/simple-logging-lib/static-1.3403",
      "cms-field-types": "/cms-field-types/static-1.5164",
      "content-icons-ui": "/content-icons-ui/static-1.2410",
      "underscore": "/underscore/static-1.8",
      "nudge-client-utils": "/nudge-client-utils/static-1.3220",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1289",
      "social-insights-client-types": "/social-insights-client-types/static-1.22728",
      "outpost": "/outpost/static-1.4499",
      "markdown-it": "/markdown-it/static-1.6",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6938",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.46822",
      "enrichment-lib": "/enrichment-lib/static-1.588",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4615",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.20307",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19340",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11132",
      "customer-data-associations": "/customer-data-associations/static-1.7682",
      "tasks-actions-lib": "/tasks-actions-lib/static-1.230",
      "reporting-data": "/reporting-data/static-1.68971",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.5105",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3800",
      "crm_universal": "/crm_universal/static-1.22555",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9675",
      "content-embed-lib": "/content-embed-lib/static-1.7690",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.13257",
      "remote-dom": "/remote-dom/static-1.5",
      "remote-ui": "/remote-ui/static-1.72",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5982",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.17978",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3362",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14582",
      "redux-observable": "/redux-observable/static-1.76",
      "ReduxMessenger": "/ReduxMessenger/static-2.10724",
      "rxjs": "/rxjs/static-5.10",
      "unified-auth": "/unified-auth/static-1.1007",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.9028",
      "data-token-picker": "/data-token-picker/static-1.16956",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8456",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6050",
      "navigation-messaging": "/navigation-messaging/static-1.8250",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19341",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18459",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1274",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.2111",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.7226",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.10018",
      "growth-data-modal": "/growth-data-modal/static-1.5963",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3418",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2779",
      "navigation-components": "/navigation-components/static-1.18923",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.5422",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8005",
      "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6798",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.11394",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.2165",
      "commerce-permissions": "/commerce-permissions/static-1.1130",
      "products-iframe-lib": "/products-iframe-lib/static-1.8674",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11085",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10786",
      "sales-views-client-types": "/sales-views-client-types/static-1.4609",
      "bark-lib": "/bark-lib/static-1.16870",
      "browser-prettier": "/browser-prettier/static-1.11",
      "codemirror": "/codemirror/static-5.103",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6242",
      "react-codemirror": "/react-codemirror/static-1.10996",
      "data-agent-kit": "/data-agent-kit/static-1.720",
      "fsm": "/fsm/static-1.4106",
      "policy-lib": "/policy-lib/static-1.7159",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.15679",
      "hubs-service-types": "/hubs-service-types/static-1.1613",
      "purchase-motions-api": "/purchase-motions-api/static-1.6468",
      "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.847",
      "breeze-engine-core": "/breeze-engine-core/static-1.1147",
      "highlight.js": "/highlight.js/static-1.87",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13345",
      "content-media-compositions": "/content-media-compositions/static-2.17352",
      "idb-keyval": "/idb-keyval/static-1.52",
      "media-bridge-lib": "/media-bridge-lib/static-1.19474",
      "fix-webm-duration": "/fix-webm-duration/static-1.31",
      "notification-sounds": "/notification-sounds/static-1.4777",
      "seat-types-lib": "/seat-types-lib/static-1.806",
      "ui-addon-opt": "/ui-addon-opt/static-4.8714",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.6693",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5434",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3882",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19652",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.9467",
      "reactive-lib": "/reactive-lib/static-1.1071",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2977",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3296",
      "whisper-core-api": "/whisper-core-api/static-1.7419",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.38091",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.13492",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55877",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22283",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18926",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72866",
      "data-agent-utils": "/data-agent-utils/static-1.650",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10425",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23933",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.8064",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6355",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.15645",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5456",
      "qrcode-generator": "/qrcode-generator/static-1.77",
      "reporting-client-types": "/reporting-client-types/static-1.2722",
      "react-flip-move": "/react-flip-move/static-1.79",
      "FireAlarmUi": "/FireAlarmUi/static-1.4756",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4418",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11455",
      "association-settings-lib": "/association-settings-lib/static-1.11104",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.58818",
      "conditional-property-settings-components": "/conditional-property-settings-components/static-1.338",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.13249",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.13475",
      "ExportDialog": "/ExportDialog/static-6.10732",
      "final-form": "/final-form/static-1.79",
      "property-management-iframe": "/property-management-iframe/static-1.14229",
      "property-usages-lib": "/property-usages-lib/static-1.5862",
      "reactflow": "/reactflow/static-1.72",
      "simple-data-table": "/simple-data-table/static-1.3604",
      "used-in-list-lib": "/used-in-list-lib/static-1.7320",
      "visual-association": "/visual-association/static-1.6247",
      "highcharts": "/highcharts/static-8.112",
      "reporting-visualizations": "/reporting-visualizations/static-1.61045",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4270",
      "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.557",
      "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1544",
      "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.57",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1120",
      "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.253",
      "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.595",
      "slack-ui-library": "/slack-ui-library/static-1.10751",
      "ai-rendering-library": "/ai-rendering-library/static-1.11189",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8411",
      "breeze-engine-ui-devtools": "/breeze-engine-ui-devtools/static-1.243",
      "copilot-plugins": "/copilot-plugins/static-1.11906",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1560",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1730",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.584",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4273",
      "ui-tool-access": "/ui-tool-access/static-1.10507",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2601",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2807",
      "user-context-client": "/user-context-client/static-1.4862",
      "nest": "/nest/static-1.589",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36942",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16452",
      "browser-eslint": "/browser-eslint/static-2.57",
      "trellis-story-utils": "/trellis-story-utils/static-1.4860",
      "storybook-react": "/storybook-react/static-1.41",
      "academy-common-lib": "/academy-common-lib/static-1.15139",
      "js-cookie": "/js-cookie/static-1.18",
      "products-ui-components": "/products-ui-components/static-1.41161",
      "settings-ui-lib": "/settings-ui-lib/static-1.12876",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7606",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.55893",
      "commerce-products-api": "/commerce-products-api/static-1.2749",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57951",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.103544",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.81587",
      "one-click-checkout": "/one-click-checkout/static-1.517",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7927",
      "reporting-ui-components": "/reporting-ui-components/static-2.66240",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15293",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19363",
      "stripe-connect-js": "/stripe-connect-js/static-1.78",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9885",
      "hub-http-contrib": "/hub-http-contrib/static-1.3387",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5561",
      "nested-table": "/nested-table/static-1.588",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23253",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3615",
      "conditional-property-settings-data": "/conditional-property-settings-data/static-1.356",
      "property-management-common": "/property-management-common/static-1.6517",
      "d3": "/d3/static-1.7",
      "breeze-onboarding-components": "/breeze-onboarding-components/static-1.828",
      "global-styles-ai-lib": "/global-styles-ai-lib/static-1.240",
      "marketplace-embed-ba": "/marketplace-embed-ba/static-1.709",
      "mermaid": "/mermaid/static-1.3",
      "reporting-action-components": "/reporting-action-components/static-1.42154",
      "reporting-snowflake": "/reporting-snowflake/static-1.57587",
      "upgrade-components-lib": "/upgrade-components-lib/static-1.582",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16658",
      "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7964",
      "academy-service-client": "/academy-service-client/static-1.4044",
      "croppie": "/croppie/static-2.10",
      "SafeStorage": "/SafeStorage/static-1.4753",
      "trellis-ecosystem": "/trellis-ecosystem/static-1.7694",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.892",
      "price-books-api": "/price-books-api/static-1.1818",
      "price-books-components": "/price-books-components/static-1.1876",
      "property-description-translator": "/property-description-translator/static-1.4183",
      "ramp-editor": "/ramp-editor/static-1.972",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3870",
      "totals-ui-components": "/totals-ui-components/static-1.24375",
      "checkout-sdk": "/checkout-sdk/static-3.24455",
      "payment-method-components": "/payment-method-components/static-1.7199",
      "touchless-buying-components": "/touchless-buying-components/static-1.6323",
      "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3796",
      "reporting-plugins": "/reporting-plugins/static-1.10826",
      "reporting-reports": "/reporting-reports/static-1.68647",
      "edison-service-client-types": "/edison-service-client-types/static-1.749",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10890",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18238",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.20831",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8375",
      "react-window": "/react-window/static-1.13",
      "ts-utils-lib": "/ts-utils-lib/static-1.501",
      "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1029",
      "marketplace-embed": "/marketplace-embed/static-1.23006",
      "marketplace-ui-install": "/marketplace-ui-install/static-1.817",
      "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15001",
      "dashboard-lib": "/dashboard-lib/static-1.82984",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9062",
      "ContentData": "/ContentData/static-1.69298",
      "line-items-api": "/line-items-api/static-1.1158",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4066",
      "hub-http-rxjs": "/hub-http-rxjs/static-1.856",
      "normalizr": "/normalizr/static-3.9",
      "ramda": "/ramda/static-1.7",
      "billing-payments-client-types": "/billing-payments-client-types/static-1.4344",
      "company-details-components": "/company-details-components/static-1.6559",
      "emoji-regex": "/emoji-regex/static-1.7",
      "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16020",
      "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3807",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.10479",
      "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3580",
      "ui-addon-calendars": "/ui-addon-calendars/static-2.5698",
      "apps-service-types": "/apps-service-types/static-1.4067",
      "oauth-service-types": "/oauth-service-types/static-1.4586",
      "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1215",
      "connections-embed-lib": "/connections-embed-lib/static-1.1581",
      "fail-safe": "/fail-safe/static-1.308",
      "ai-studio-lib": "/ai-studio-lib/static-1.12513",
      "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.554",
      "ui-product-approvals": "/ui-product-approvals/static-1.29320",
      "redux-actions": "/redux-actions/static-3.71",
      "advanced-menus-core": "/advanced-menus-core/static-1.15643",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.12506",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34933",
      "company-details-service-types": "/company-details-service-types/static-1.4295",
      "pricing-pages-api": "/pricing-pages-api/static-1.15885",
      "copilot-messaging": "/copilot-messaging/static-1.2184",
      "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.259",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.15642",
      "simple-menus-lib": "/simple-menus-lib/static-1.17159"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.30809",
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};